import ColorUtils from '~/common/color-utils';

export const getMutedColor = (color: string, opacity = 70) => ColorUtils.getColorWithOpacity(color, opacity);
